/**
 * Platform-conditional feature flags.
 *
 * Some features are disabled on iOS to comply with App Store guidelines.
 * Specifically: anything that unlocks content via a mechanism other than
 * Apple In-App Purchase (guideline 3.1.1).
 *
 * GunfighterOS cross-app linking grants bonuses (XP, intel multipliers,
 * cosmetics) — those qualify as "unlocked content" and were flagged in
 * App Store review on 2026-05-30. Disable on iOS native; web + Android
 * keep the feature.
 */

import { Capacitor } from '@capacitor/core';

function getPlatform(): 'ios' | 'android' | 'web' {
  try {
    const p = Capacitor.getPlatform();
    if (p === 'ios') return 'ios';
    if (p === 'android') return 'android';
    return 'web';
  } catch {
    return 'web';
  }
}

/**
 * GunfighterOS cross-app linking + bonus surfaces. Disabled on iOS for
 * App Store compliance. Returns true on web + Android, false on iOS.
 */
export function isGunfighterEnabled(): boolean {
  return getPlatform() !== 'ios';
}

/** Is the app running natively on iOS via Capacitor? */
export function isIosNative(): boolean {
  return getPlatform() === 'ios';
}
